$(document).ready(function(){
  var frequency = null;
  function initialize() {
    $("#subscribeBtn").off("click");
    $("#oneTimeBtn").off("click");
    $("#dropdownButton").off("click");
    $(document).off("click");
    $(".dropdown-item").off("click");
    if (frequency === null) {
      $(".cart-drawer__footer #deliveryGeoSearchField").attr("disabled", false);
    }
    
     // 
    $("#dropdownButton").click(function(event) {
      $("#dropdownContent").toggle();

      $(this).toggleClass("active");

      event.stopPropagation();
    });

    $("#oneTimeBtn").click(function() {
      const enabledCheckout = Zapiet.Widget.checkoutEnabled();
      if (enabledCheckout) {
        window.location = '/checkout';
      }
    });

    $(document).click(function(event) {
      if (!$(event.target).closest("#dropdownButton, #dropdownContent").length) {
        $("#dropdownContent").hide();  
        $("#dropdownButton").removeClass("active"); 
      }
    });
    $(".dropdown-item").click(async function(e) {
      var selectedText = $(this).text();  
      var selectedValue = $(this).data("value");  
      var checkValues = [selectedValue, selectedValue.slice(0, -1)];

      $("#selectedOption").text(selectedText);
      
      try {
        const [cart, products] = await Promise.all([
          window.ReChargeWidget.api.getCart(),
          window.ReChargeWidget.api.fetchProducts()
        ]);
          
          $.ajax({
              type: 'POST',
              url: '/cart/clear.js',
              dataType: 'json',
              data: {},
              success: async () => {
                  const listAdd = [];
                  cart.items.forEach(item => {
                      const product = products.find(pd => pd[item.product_id])?.[item.product_id];
                      const sellingPlanId = product.selling_plan_groups.find(item => checkValues.includes(item.selling_plans[0]['selling_plan_name']))?.selling_plans[0]['selling_plan_id'];
                      const dataAdd = {
                          "id": item.variant_id || item.id,
                          "quantity": item.quantity,
                          "selling_plan": sellingPlanId
                      };
                      listAdd.push(dataAdd);
                  });

                  addItemsToCart(listAdd?.reverse());
              },
              error: function(error) {
                  console.error('Error', error);
              }
          });
      } catch (error) {
          console.error(error);
      }

      $("#dropdownContent").hide();
      $("#dropdownButton").removeClass("active"); 
  });
  
  }

  initialize();
  function updateCartDrawer() {
      $.ajax({
          type: 'GET',
          url: '/cart',
          success: function(data) {
              $('.drawer__cart-items-wrapper').html($(data).find('.drawer__cart-items-wrapper').html());
          },
          error: function(error) {
              console.error('Error updating cart drawer:', error);
          }
      });
  }

  function addItemsToCart(items) {
      data = {
          items
      }
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() { 
          updateCartDrawer();
          frequency = true;
        }
      });
  }

  // Detect DOM change in cart
  var observer = new MutationObserver(function(mutations) {
    let count = 0;
    mutations.forEach((mutation) => {
      // if (mutation.target.id !== "step_1_name") {
      //   count++;
      // }
      count++;
    });
    if (count > 0) {
      initialize();
    }
  });

  observer.observe(document.querySelector("cart-drawer"), {  childList: true, subtree: true });
});

